import {
  gestioneTabs,
  nngTabs,
  NumeriSpeciali_Piani_Di_Instradamento,
} from "../../util/constants";

export const numeriSpecialiPapers = [
  {
    id: 1,
    title: nngTabs.ASSOCIAZIONE,
  },
  {
    id: 2,
    title: "Gestione",
    expanded: false,
    menu: [
      gestioneTabs.GESTIONE_NUMERI_NERI,
      gestioneTabs.AREE_DI_ORIGINE_CHIAMATE,
      gestioneTabs.FASCE_ORARIE,
      gestioneTabs.MESSAGI_VOCALI,
    ],
  },
  {
    id: 3,
    title: "Piani di Instradamento",
    isAccordion: true,
    expanded: false,
    menu: [
      NumeriSpeciali_Piani_Di_Instradamento.CHIAMATE,
      NumeriSpeciali_Piani_Di_Instradamento.LISTE_BIANCHE,
      NumeriSpeciali_Piani_Di_Instradamento.MESSAGGI,
      NumeriSpeciali_Piani_Di_Instradamento.REGOLE,
      NumeriSpeciali_Piani_Di_Instradamento.INSTRADAMENTI,
    ],
  },
  // {
  //   id: 4,
  //   title: "Storico configurazioni",
  // },
];
